export default __webpack_public_path__ + "static/media/coSafe.c798a066.png";